module.exports = __webpack_public_path__ + "static/media/lighting.52721222.svg";